import {dayjs} from '@myparcel-frontend/utils';

// Checks if a specific time of day has already passed compared to the current time.
export const timeOfDayHasPassed = (time: string): boolean => {
  const now = dayjs();
  const [hours, minutes] = time.split(':');
  const timeToday = dayjs().hour(parseInt(hours)).minute(parseInt(minutes));

  return now.isAfter(timeToday);
};
